import { c as _c } from "react/compiler-runtime";
import { PinInput } from '@onefootprint/ui';
import type { ResendButtonProps } from './components/resend-button';
import ResendButton from './components/resend-button';
import Success from './components/success';
import Verifying from './components/verifying';
export type PinFormProps = Omit<ResendButtonProps, 'texts'> & {
  children?: React.ReactNode;
  hasError?: boolean;
  pinFormHint?: string;
  isPending?: boolean;
  isSuccess?: boolean;
  isVerifying?: boolean;
  onComplete: (code: string) => void;
  title?: string;
  texts: ResendButtonProps['texts'] & {
    success: string;
    verifying: string;
  };
  className?: string;
};
const PinForm = t0 => {
  const $ = _c(28);
  const {
    children,
    hasError,
    pinFormHint,
    isPending,
    isResendLoading,
    isSuccess,
    isVerifying,
    onComplete,
    onResend,
    resendDisabledUntil,
    texts,
    title,
    className
  } = t0;
  if (isSuccess) {
    let t1;
    if ($[0] !== texts.success) {
      t1 = <Success text={texts.success} />;
      $[0] = texts.success;
      $[1] = t1;
    } else {
      t1 = $[1];
    }
    return t1;
  }
  if (isVerifying) {
    let t1;
    if ($[2] !== texts.verifying) {
      t1 = <Verifying text={texts.verifying} />;
      $[2] = texts.verifying;
      $[3] = t1;
    } else {
      t1 = $[3];
    }
    return t1;
  }
  const t1 = !!isPending;
  const t2 = `flex flex-col gap-4 justify-center items-center text-center ${className ?? ""}`;
  let t3;
  if ($[4] !== title) {
    t3 = title && <h3 className="text-body-2 text-secondary fp-text" data-dd-privacy="mask">{title}</h3>;
    $[4] = title;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== hasError || $[7] !== isPending || $[8] !== onComplete || $[9] !== pinFormHint) {
    t4 = <PinInput disabled={isPending} onComplete={onComplete} hasError={hasError} hint={pinFormHint} testID="verification-form-pin-input" autoFocus={true} />;
    $[6] = hasError;
    $[7] = isPending;
    $[8] = onComplete;
    $[9] = pinFormHint;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== texts.resendCountDown || $[12] !== texts.resendCta) {
    t5 = {
      resendCountDown: texts.resendCountDown,
      resendCta: texts.resendCta
    };
    $[11] = texts.resendCountDown;
    $[12] = texts.resendCta;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] !== isResendLoading || $[15] !== onResend || $[16] !== resendDisabledUntil || $[17] !== t5) {
    t6 = <ResendButton isResendLoading={isResendLoading} onResend={onResend} resendDisabledUntil={resendDisabledUntil} texts={t5} />;
    $[14] = isResendLoading;
    $[15] = onResend;
    $[16] = resendDisabledUntil;
    $[17] = t5;
    $[18] = t6;
  } else {
    t6 = $[18];
  }
  let t7;
  if ($[19] !== children || $[20] !== t6) {
    t7 = <div className="flex flex-col w-full items-center justify-center gap-2 mb-4">{t6}{children}</div>;
    $[19] = children;
    $[20] = t6;
    $[21] = t7;
  } else {
    t7 = $[21];
  }
  let t8;
  if ($[22] !== t1 || $[23] !== t2 || $[24] !== t3 || $[25] !== t4 || $[26] !== t7) {
    t8 = <form autoComplete="off" role="presentation" data-pending={t1} className={t2}>{t3}{t4}{t7}</form>;
    $[22] = t1;
    $[23] = t2;
    $[24] = t3;
    $[25] = t4;
    $[26] = t7;
    $[27] = t8;
  } else {
    t8 = $[27];
  }
  return t8;
};
export default PinForm;